var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "n\\xE3o-participa",
    transform: "translate(0.001 -0.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1494",
    "data-name": "Caminho 1494",
    d: "M28.9,7.856l-6.59-6.589a3.719,3.719,0,0,0-2.651-1.1H10.341a3.717,3.717,0,0,0-2.651,1.1L1.1,7.856A3.724,3.724,0,0,0,0,10.507v9.321a3.722,3.722,0,0,0,1.1,2.651l6.59,6.59a3.724,3.724,0,0,0,2.651,1.1h9.321a3.721,3.721,0,0,0,2.651-1.1l6.591-6.59A3.724,3.724,0,0,0,30,19.828V10.508a3.718,3.718,0,0,0-1.1-2.652Zm0,0",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1495",
    "data-name": "Caminho 1495",
    d: "M146.4,144.617a1.363,1.363,0,1,1-1.928,1.928l-4.1-4.1-4.1,4.1a1.363,1.363,0,1,1-1.928-1.928l4.1-4.1-4.1-4.1a1.363,1.363,0,1,1,1.928-1.928l4.1,4.1,4.1-4.1a1.363,1.363,0,0,1,1.928,1.928l-4.1,4.1Zm0,0",
    transform: "translate(-125.387 -125.365)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegado);
export default __webpack_public_path__ + "static/media/negado.3c30000dc0cb69d1f46e33d8ba44e6c1.svg";
export { ForwardRef as ReactComponent };